"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TagId;
(function (TagId) {
    TagId[TagId["EVCredit"] = 116] = "EVCredit";
    TagId[TagId["GreatDeal"] = 104] = "GreatDeal";
    TagId[TagId["PriceDrop"] = 103] = "PriceDrop";
})(TagId || (TagId = {}));
exports.default = TagId;
//# sourceMappingURL=TagIds.js.map